import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { SbPremiumService } from './sb-premium.service';

/**
 * Marks a paid feature on its label; clicking it says what that means. As a label (asLabel) it is
 * only the mark, for inside a button, where the button or its app-sb-premium-lock takes the click.
 */
@Component({
  selector: 'app-sb-premium-badge',
  template: `
    @if (asLabel()) {
    <span class="sb-premium-badge sb-premium-badge--label" title="Paid feature">
      <i class="fa fa-diamond" aria-hidden="true"></i><span>Premium</span>
    </span>
    } @else {
    <button type="button" class="sb-premium-badge" title="Paid feature"
            (click)="$event.stopPropagation(); $event.preventDefault(); premium.explain(feature())">
      <i class="fa fa-diamond" aria-hidden="true"></i><span>Premium</span>
    </button>
    }
  `,
  styleUrls: ['./sb-premium.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbPremiumBadgeComponent {
  protected readonly premium = inject(SbPremiumService);

  /** The feature's name, as the popup names it. */
  readonly feature = input.required<string>();

  /** Only the mark, not a button: for inside a button. */
  readonly asLabel = input(false);
}
